import { Modal } from 'antd';
import { ApsModalHeader, ApsModalBody, ApsButton, ApsButtonGroup } from 'UserExperience/portal-vnext';

const ExpiredLinkModal = ({ visible, onOk }) => {

  const modalTitle = 'The document request link has expired, please contact customer service. ';
  const yesButtonLabel = 'Ok';

  return (
    <Modal
      visible={visible}
      closable={false}
      footer = {null}
      centered={true}
      wrapClassName="modal-size-is-small"
      bodyStyle={{padding:0, fontSize: 16}}
      width={280}
      destroyOnClose={true}
    >
      {/* existing portal css needs some wrapper element so modal font, etc., will be applied */}
      <emulate-ng-include>
        <ApsModalHeader
          titleText={modalTitle}
          titleAlign="center"
          titleSize="small"
          closeButton={false}
        />
        <ApsModalBody hasPadding={true}>
          <ApsButtonGroup
            groupInset={true}
            groupType="separate"
          >
            <ApsButton
              buttonBlock={true}
              buttonLabel={yesButtonLabel}
              buttonShape="pill"
              buttonType="primary"
              onClick={onOk}
            />
          </ApsButtonGroup>
        </ApsModalBody>
      </emulate-ng-include>
    </Modal>
  );
};

export default ExpiredLinkModal;